import { connect } from '@collaborator/npm_modules/dist/components/redux';
import { State } from 'moduleBase/types/State';
import { ActionCreatorsMapObject, bindActionCreators } from 'redux';
import { StateType } from 'moduleChat/modules/modal/types/StateType';
import { REDUCER_CHAT_MODAL_NAME } from 'moduleChat/modules/modal/constants';
import React, { FC, lazy, Suspense } from 'react';
import { Modal } from '@collaborator/npm_modules/dist/components/modal';
import { chatModalHide } from 'moduleChat/modules/modal/actions/hide';
import { reducerChatModal } from 'moduleChat/modules/modal/reducers';

const Thread = lazy(() => import('moduleChatThread/containers/Thread'));

type DispatchPropsType = {
  hide: () => void;
};

type PropTypes = StateType & DispatchPropsType;

const ChatModal: FC<PropTypes> = ({
  isVisible,
  creUserId,
  dealId,
  hide,
}) => (
  <div>
    <Modal show={isVisible} onHide={hide} size="lg" centered>
      <Modal.Title onHide={hide} />
      <Modal.Body className="d-flex h-700p modal__body_extended mb-0">
        <Suspense fallback="">
          <Thread creUserId={creUserId} dealId={dealId} />
        </Suspense>
      </Modal.Body>
    </Modal>
  </div>
);

export default connect<StateType, DispatchPropsType>(ChatModal, {
  reducers: [
    { name: REDUCER_CHAT_MODAL_NAME, reducer: reducerChatModal },
  ],
  mapStateToProps: (state: State) => state[REDUCER_CHAT_MODAL_NAME],
  mapDispatchToProps: (dispatch) => (bindActionCreators<ActionCreatorsMapObject, DispatchPropsType>({
    hide: chatModalHide,
  }, dispatch)),
});
